import { Link } from 'react-router-dom';
import { articles } from '@/mocks/categories';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Guias e Artigos SEO
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-md">
              Conteudo exclusivo sobre como usar o hoobuyspreadsheet, dicas de compra e guias completos para iniciantes.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer self-start"
          >
            Ver Spreadsheet Completo
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        {/* Article Cards - 10 articles */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, i) => {
            const badges = [
              'Guia Completo', 'Guia de Tenis', 'Top Produtos', 'Comparacao',
              'Guia de Tamanhos', 'Guia Fiscal', 'Fornecedores', 'Guia de Revenda',
              'Guia Iniciante', 'Tendencias'
            ];
            const badgeIcons = [
              'ri-fire-fill', 'ri-footprint-line', 'ri-star-fill', 'ri-scales-line',
              'ri-ruler-line', 'ri-file-text-line', 'ri-store-line', 'ri-shopping-bag-line',
              'ri-rocket-line', 'ri-palette-line'
            ];

            return (
              <Link
                key={article.slug}
                to={`/artigo/${article.slug}`}
                className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                {/* Card Image */}
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Card Content */}
                <div className="p-5">
                  {/* Meta */}
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                      <i className={`${badgeIcons[i % badgeIcons.length]} text-[10px]`}></i>
                      {badges[i % badges.length]}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime} de leitura</span>
                  </div>

                  {/* Title */}
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>

                  {/* Description */}
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2 mb-4">
                    {article.description}
                  </p>

                  {/* Date & Read button */}
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-foreground-950 text-background-50 text-xs font-semibold rounded-full group-hover:bg-primary-500 transition-colors duration-200 whitespace-nowrap">
                      Ler Artigo
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* View All */}
        <div className="text-center mt-10 md:mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold text-sm rounded-full hover:bg-foreground-50 hover:border-foreground-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Ver Mais Conteudo no Kaspreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}